import { useContext } from 'react'
import { ActiveManagementHeaderSlotContext } from './ActiveManagementHeaderSlotContext'

export function useActiveManagementHeaderSlot() {
    return useContext(ActiveManagementHeaderSlotContext)
}
